<template>
    <fieldset>
        <legend>Project tags</legend>
        <div class="project-tags">
            <span class="pill" v-for="(item, index) in projectTags" :key="index">
                {{ item }}
                <span class="click" @click="removeTag(item)">
                    &#10005;
                </span>
            </span>
        </div>
        <!--input type="list" :list="listId"-->
        <div class="short">
            <label>
                <span class="label">Assign Tag:</span>
                <div class="short">
                    <!--<FormItem :name="'tags:'">-->
                        <input :list="listId" v-model="selected" placeholder="type to add tag..." />
   
                    <!--</FormItem>-->
                        <button type="button" @click="addTagToProject">add</button>
                        
                    
                </div>
            </label>

        </div>




        <datalist :id="listId">
            <option v-for="(item, index) in options" :key=index :value=item></option>
        </datalist>

        <div class="debug">
            <p>options :</p>
            <p>{{ options }}</p>
        </div>
    </fieldset>

</template>


<script setup lang="ts">
import { computed, ref } from 'vue';
import { useTagStore } from '@/stores';
import { FormBtn, FormListbox } from '@/components/form';

//import { storeToRefs } from 'pinia';
const tagStore = useTagStore();

//TODO store fetcher on tagstore 

//generate random (hopefully unique) id
const listId = computed(() => {
    let x = Math.floor(Math.random() * 1000000 + 1)
    return `datalist-tags-${x}`
})
const options = ref([]);
await getTags();

//from the project
const projectTags = defineModel<any>('projectTags');

//is selected relevant?
const selected = ref('');


function addTagToProject() {
    console.log("..adding tag")
    //add to projectTags
    if (selected.value && selected.value != null && selected.value != '') {
        projectTags.value.push(selected.value);
    }

    //create the list item in the ul
    //clear the input
    selected.value = '';
}

async function getTags() {
    const allTags = await tagStore.getAll();
    options.value = allTags;
    /*options.value = allTags.map(tag => {
        return tag.name;
    });*/
}

function removeTag(tag: String) {
    console.log(`..removeTag(${tag})`);
    //let temp = projectTags.value.splice(0,projectTags.value.indexOf(tag));
    projectTags.value.splice(projectTags.value.indexOf(tag), 1);
    //console.log("..temp = " + temp);
}


</script>

<style lang="css" scoped>
div.project-tags {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

span.pill {
    background-color: var(--blue);
    color: white;
    padding: 1rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    border-radius: 1rem;
    text-align: center;
}

span.click {
    margin-left: 0.5rem;
}

span.click:hover {
    cursor: pointer;
    color: black;
}

span.label {
      display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

div.short {
    width: 20rem;
    display: flex;
    flex-direction: row;
}

input {
   display: block;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  background-color: white;
  border: 1px solid grey;
 

  border-top-left-radius: 0.375rem;
   border-bottom-left-radius: 0.375rem;
  font-size: 1rem;
}

button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
</style>